import type { ChipId, Prediction, QuestId, QuestPickState } from './types'

export interface OtherPlayerGameweekPicks {
  predictions: Record<string, Prediction>
  bankerGameId: string | null
  activeChipId: ChipId | null
  questPicks: Partial<Record<QuestId, QuestPickState>>
}

/**
 * Another player's picks for a gameweek are now their real, simulated rows, fetched via
 * `loadPlayerGameweekPicks` — no longer a deterministic hash stand-in. This is
 * the empty bundle shown while that fetch is in flight, or for a player who never picked (they
 * have no rows yet / were reset).
 */
export function emptyOtherPlayerGameweekPicks(): OtherPlayerGameweekPicks {
  return { predictions: {}, bankerGameId: null, activeChipId: null, questPicks: {} }
}
